var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteRedOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete_outline_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.672,
    height: 18.672,
    viewBox: "0 0 18.672 18.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7183",
    "data-name": "Path 7183",
    d: "M0,0H18.672V18.673H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7263",
    "data-name": "Path 7263",
    d: "M5.778,15.448A1.561,1.561,0,0,0,7.334,17h6.224a1.561,1.561,0,0,0,1.556-1.556V7.668a1.561,1.561,0,0,0-1.556-1.556H7.334A1.561,1.561,0,0,0,5.778,7.668Zm2.334-7.78H12.78a.78.78,0,0,1,.778.778V14.67a.78.78,0,0,1-.778.778H8.112a.78.78,0,0,1-.778-.778V8.446A.78.78,0,0,1,8.112,7.668Zm5.057-3.89-.552-.552A.785.785,0,0,0,12.072,3H8.82a.785.785,0,0,0-.545.226l-.552.552H5.778a.778.778,0,0,0,0,1.556h9.336a.778.778,0,0,0,0-1.556Z",
    transform: "translate(-1.11 -0.666)",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRedOutline);
export default __webpack_public_path__ + "static/media/delete-red-outline.12e8a6f4a285981d4e3a3afafdf61c80.svg";
export { ForwardRef as ReactComponent };